// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_17TiHL","card":"_3bDCw7","cardHeading":"_2S1clJ","cartTitle":"aRM38z","cardSubtitle":"_1iu_Mo","cardIcon":"_1o0A-0"};